__webpack_require__.p = "https://jcs-chat-widget.atlassian.com/assets/";